import Point from 'ol/geom/point';
import Fill from 'ol/style/fill';
import Stroke from 'ol/style/stroke';
import Text from 'ol/style/text';
import Circle from 'ol/style/circle';
import Style from 'ol/style/style';
import colorlike from 'ol/colorlike';

const canvas = document.createElement('canvas');
const context = canvas.getContext('2d');

const grd = context.createRadialGradient(5.00, 5.00, 1.000, 5.00, 5.00, 5.00);
// Add colors
grd.addColorStop(0.000, 'rgba(255, 238, 0, 1.000)');
grd.addColorStop(0.200, 'rgba(255, 238, 0, 1.000)');
// grd.addColorStop(0.340, 'rgba(255, 255, 255, 1.000)');
// grd.addColorStop(0.600, 'rgba(234, 189, 12, 1.000)');
grd.addColorStop(1.000, 'rgba(255, 238, 0, 0)');

window.grd = grd;

const grayFill = new Fill({
  color: 'rgba(150,150,150,0.7)'
});

const blueFill = new Fill({
  color: 'rgba(55,179,224,0.7)'
});

const orangeFill = new Fill({
  color: 'rgba(255,119,0,0.9)'
});

const yellowFill = (opacity) => {
  return new Fill({
    color: grd
    //color: `rgba(255,238,0,${opacity})`
  })
};

const textFill = new Fill({
  color: '#fff'
});

const textStroke = new Stroke({
  color: 'rgba(0, 0, 0, 0.6)',
  width: 3
});

const stroke = new Stroke({
  color: 'white',
  width: 0.5
})

const blackStroke = new Stroke({
  color: 'black',
  width: 0.5
})

export const activeProfileStyles = [
  new Style({
    image: new Circle({
      fill: blueFill,
      radius: 8,
      stroke: stroke
    }),
  })
];

export const defaultProfileStyles = [
  new Style({
    image: new Circle({
      fill: grayFill,
      radius: 5,
      stroke: stroke
    }),
  })
];

export const warningProfileStyles = [
  new Style({
    image: new Circle({
      fill: orangeFill,
      radius: 5,
      stroke: stroke
    }),
  })
];

export const drawCursorStyles = [
  new Style({
    image: new Circle({}),
    fill: blueFill,
    stroke: blackStroke,
  })
]



export const visualDeviceStyles = (profile, sliderValue, profileMode, day, todaysEvents) => {
  // appearently rarely prifiles don't have a default brightness
  if (!profile.brightness) {
    return warningProfileStyles;
  }

  const visualCircle = new Circle({
    fill: yellowFill(1),
    //fill: grd,
    radius: 5,
    snapToPixel: false
  });

  return (f) => {
    const modus = f.get('modus'); //"fixed_level", "scheduling", "dynamic_dimming"

    if (modus === "fixed_level") {
      visualCircle.setOpacity( f.get('lamp_brightness_percentage') / 100)
      return new Style({
        image: visualCircle,
      });
    }

    if (todaysEvents.length > 0) {
      // let try supporting one event a day first
      const schedule = todaysEvents[0].schedules.find(s => s.device_addresses.indexOf(f.get('uid')) !== -1);
      if (schedule) {
        visualCircle.setOpacity(getProfileBrightnessAt(schedule.settings, sliderValue, modus === 'dynamic_dimming' ? profileMode : 'high') / 100);
        return new Style({
          image: visualCircle
        });
      }
    }
    const brightness = profile.brightness[day] || profile.brightness['default'];
    visualCircle.setOpacity(getProfileBrightnessAt(brightness, sliderValue, modus === 'dynamic_dimming' ? profileMode : 'high') / 100);

    return new Style({
      image: visualCircle
    });
  }
}

export const clusterStyles = (feature) => {
  const feature_count = feature.get('features').length;

  return new Style({
    image: new Circle({
      fill: blueFill,
      radius: 12,
      stroke: stroke
    }),
    text: new Text({
      text: feature_count.toString(),
      fill: textFill,
      stroke: textStroke
    })
  });
};

function getProfileBrightnessAt(brightness, sliderValue, profileMode) {
  if(!brightness)
    return 0;

  let brightness_percentage = 0;
  brightness.forEach((b) => {
    const hours = parseInt(b.time.split(":")[0]);
    const minutes = parseInt(b.time.split(":")[1]);

    let totalMinutes = (hours * 60) + minutes - 720;

    //let convertedTime = parseInt((b.time.split(":")[0] * 60) + (b.time.split(":")[1]));

    if(totalMinutes < 0) {
      totalMinutes += 1440;
    }

    if(totalMinutes <= sliderValue) {
      brightness_percentage = b[profileMode];
    }
  });

  return brightness_percentage;
}



// WEBPACK FOOTER //
// ./src/mapStyles/index.js